<template>
  <KalaStoreShared />
</template>

<script>
import KalaStoreShared from '@/components/KalaStoreShared.vue'

export default {
  name: 'CustomerKalaStoreView',
  components: { KalaStoreShared },
}
</script>
